module.exports = __webpack_public_path__ + "img/login-three.08f357d6.png";